import HeaderPage from "../../../shared/components/HeaderPage/HeaderPage";
import use123zapStore from "../../../context/123zapStore";

import SheetsAddContent from "./SheetsAddContent";
import { useSheetsOptions } from "./useSheetsOptions";

function AddSheetsOptions() {
  const featureAccess = use123zapStore((state) => state.featureAccess);

  const { sheetsData, isLoadingErp } = useSheetsOptions(featureAccess);

  return (
    <>
      <HeaderPage />
      <SheetsAddContent
        sheetsData={sheetsData}
        isLoadingErp={isLoadingErp}
      />
    </>
  );
}

export default AddSheetsOptions;
